"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const base_models_1 = require("@integration/base-models");
class GetDefaultPropositionsResponseCombinationCashbackItems extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.LOWER_CASE),
    (0, base_models_1.Docs)({ example: 90, description: 'Cashback value excl. VAT' }),
    tslib_1.__metadata("design:type", Number)
], GetDefaultPropositionsResponseCombinationCashbackItems.prototype, "cashbackAmount", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.LOWER_CASE),
    (0, base_models_1.Docs)({ example: 'C_D', description: 'The incentive ID set by AOM or by the Offer Store' }),
    tslib_1.__metadata("design:type", String)
], GetDefaultPropositionsResponseCombinationCashbackItems.prototype, "cashbackKey", void 0);
tslib_1.__decorate([
    (0, base_models_1.IsNullable)(),
    (0, class_validator_1.IsNumber)(),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.LOWER_CASE),
    (0, base_models_1.Docs)({ example: 1100, description: '(kWh) Start of the range where the cashback should be applied. When null, no start range is applied.' }),
    tslib_1.__metadata("design:type", Object)
], GetDefaultPropositionsResponseCombinationCashbackItems.prototype, "electricityRangeStart", void 0);
tslib_1.__decorate([
    (0, base_models_1.IsNullable)(),
    (0, class_validator_1.IsNumber)(),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.LOWER_CASE),
    (0, base_models_1.Docs)({ example: 1400, description: '(kWh) End of the range where the cashback should be applied. When null, no start range is applied.' }),
    tslib_1.__metadata("design:type", Object)
], GetDefaultPropositionsResponseCombinationCashbackItems.prototype, "electricityRangeEnd", void 0);
tslib_1.__decorate([
    (0, base_models_1.IsNullable)(),
    (0, class_validator_1.IsNumber)(),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.LOWER_CASE),
    (0, base_models_1.Docs)({ example: 2100, description: '(m³) Start of the range where the cashback should be applied. When null, no start range is applied.' }),
    tslib_1.__metadata("design:type", Object)
], GetDefaultPropositionsResponseCombinationCashbackItems.prototype, "gasRangeStart", void 0);
tslib_1.__decorate([
    (0, base_models_1.IsNullable)(),
    (0, class_validator_1.IsNumber)(),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.LOWER_CASE),
    (0, base_models_1.Docs)({ example: 2400, description: '(m³) End of the range where the cashback should be applied. When null, no start range is applied.' }),
    tslib_1.__metadata("design:type", Object)
], GetDefaultPropositionsResponseCombinationCashbackItems.prototype, "gasRangeEnd", void 0);
tslib_1.__decorate([
    (0, base_models_1.IsNullable)(),
    (0, class_validator_1.IsNumber)(),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.LOWER_CASE),
    (0, base_models_1.Docs)({ example: 1, description: 'The profile to which this cashback should be applied to. When null, it will be applied for all postcodes.' }),
    tslib_1.__metadata("design:type", Object)
], GetDefaultPropositionsResponseCombinationCashbackItems.prototype, "profileId", void 0);
tslib_1.__decorate([
    (0, base_models_1.IsNullable)(),
    (0, class_validator_1.IsNumber)(),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.LOWER_CASE),
    (0, base_models_1.Docs)({ example: 21, description: 'The ID of the current supplier of the visitor. Used if the cashback is applied for customers of a specific supplier. When null, it is applied for all current suppliers.' }),
    tslib_1.__metadata("design:type", Object)
], GetDefaultPropositionsResponseCombinationCashbackItems.prototype, "currentSupplierId", void 0);
tslib_1.__decorate([
    (0, base_models_1.IsNullable)(),
    (0, class_validator_1.IsNumber)(),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.LOWER_CASE),
    (0, base_models_1.Docs)({ example: 3, description: 'ID of a specific network. Used if the cashback is for customers on a specific network. When null, it is applied to all networks.' }),
    tslib_1.__metadata("design:type", Object)
], GetDefaultPropositionsResponseCombinationCashbackItems.prototype, "networkId", void 0);
exports.default = GetDefaultPropositionsResponseCombinationCashbackItems;
